import * as React from "react";
import { Typography, Button, Form, DatePicker } from "antd";
import { IOrganisationIndexCategory } from "../../../organisations/model/OrganisationIndexCategory";
import SelectInput from "../../../core/ui/components/SelectInput";
import { IUser } from "../../../user/model/User";
import { IOrganisation } from "../../../organisations/model/Organisation";
import moment from "moment";
import { IIndexTypeCategory } from "../../../indexTypes/model/IndexTypeCategory";

const { RangePicker } = DatePicker;

export interface State {}
export interface Props {
  translate: any;
  indexCategories: IIndexTypeCategory[];
  setCategoryId: (categoryId: number) => void;
  selectedCategoryId: number;
  user?: IUser;
  organisationIds?: number[];
  setOrganisationIds: (organisationId: number[]) => void;
  organisations?: IOrganisation[];
  fromDate?: Date;
  toDate?: Date;
  onChangeDateRange(fromDate: Date, toDate: Date): void;
}

export default class OrganisationIndexByDateParamBox extends React.Component<
  Props,
  State
> {
  constructor(props: any) {
    super(props);
    this.state = { ...props, selectedApplicants: [] };
  }

  render() {
    const {
      translate,
      selectedCategoryId,
      indexCategories,
      setCategoryId,
      organisationIds,
      organisations,
      setOrganisationIds,
      fromDate,
      toDate,
      onChangeDateRange
    } = this.props;

    let dateRange: moment.Moment[] = [];
    dateRange[0] = moment(fromDate);
    dateRange[1] = moment(toDate);

    return (
      <div
        style={{
          width: "22%",
          display: "flex",
          flexDirection: "column",
          minWidth: "22%",
          paddingRight: "10px"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: 10,
            height: "auto"
          }}
        >
          <Form.Item>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("reports.index_by_date.organisation")}
            </Typography.Title>
            <SelectInput
              placeholder={translate(
                "reports.index_by_date.select_organisation"
              )}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"id"}
              selectOptionValue={"name"}
              selectOptions={organisations}
              value={organisationIds}
              mode={"multiple"}
              onChange={(value) => setOrganisationIds(value)}
            />
          </Form.Item>
          <Form.Item>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("reports.category")}
            </Typography.Title>
            <SelectInput
              placeholder={translate("reports.select_categories")}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"id"}
              selectOptionValue={"name"}
              selectOptions={indexCategories}
              value={selectedCategoryId}
              onChange={(value) => setCategoryId(value)}
            />
          </Form.Item>
          <Form.Item>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("reports.index_by_date.date_range")}
            </Typography.Title>
            <RangePicker
              value={[dateRange[0], dateRange[1]]}
              onChange={(value) => {
                if (value && value[0] && value[1]) {
                  onChangeDateRange(value[0].toDate(), value[1].toDate());
                }
              }}
              format="DD.MM.yyyy"
            />
          </Form.Item>
        </div>
        <Button
          disabled={
            !selectedCategoryId ||
            !organisationIds?.length ||
            !fromDate ||
            !toDate
          }
          style={{ marginTop: "20px" }}
          type="primary"
          rel="noopener noreferrer"
          href={`/api/reports/indexes-by-date/xlsx?indexCategoryId=${selectedCategoryId}&organisationIds=${organisationIds}&fromDate=${fromDate?.getTime()}&toDate=${toDate?.getTime()}`}
          target="_blank"
        >
          {translate("reports.generate_report_xlsx")}
        </Button>
      </div>
    );
  }
}
